import Papa, { ParseResult } from 'papaparse'

/**
 * parse csv from url
 * @param {string} fileUrl
 */
export function parseCsvFromUrl<T>(fileUrl: string): Promise<ParseResult<T>> {
  return new Promise((resolve, reject) =>
    Papa.parse(fileUrl, {
      download: true,
      header: true,
      skipEmptyLines: true,
      complete(results: ParseResult<T>) {
        resolve(results)
      },
      error(error: Error) {
        reject(error)
      },
    })
  )
}
